import FormField from 'Components/FormComponents/FormField';
import Button from 'Components/FormComponents/Button';
import {ReactComponent as CloseIcon} from 'assets/icons/close.svg';
import {useCallback} from 'react';
import {useIntl} from 'react-intl';
import formCallbacks from 'utils/formCallbacks';

const SidebarFilters = (
  {
    formState,
    setFormState,
    formConfig,
    facets = {},
    disjunctiveFacets = {},
    clearCallback,
    filtersVisibility,
    setFiltersVisibility,
    filtersState,
    setFilters,
    maxPrice,
    priceQuery,
  }) => {
  const intl = useIntl();

  const fields = useCallback(() => {

    return formConfig.map((field) => {
      const {type, name} = field;
      let result = {}

      if (facets.hasOwnProperty(field.name)) {
        if (type === 'checkboxes' || type === 'select' || type === 'radios') {
          const options = [];
          for (const [key, value] of Object.entries(facets[name])) {
            let newLabel = '';
            if (field.name === 'field_prgm_type') {
              newLabel = key === 'Standard' ? 'Study Abroad' : key === 'Internship' ? 'Full-Time Internship' : key;
            }
            options.push({
              label: `${newLabel ? newLabel : key} (${value})`,
              value: key
            });
          }

          if (type === 'select' || type === 'radios') {
            options.unshift({
              label: '- Any -',
              value: '',
              selected: true
            })
          }

          field.options = options;
          field.isTranslated = false;
        }
        result = field;
      } else if (disjunctiveFacets.hasOwnProperty(field.name)) {
        if (type === 'checkboxes' || type === 'select' || type === 'radios') {
          const options = [];
          for (const [key, value] of Object.entries(disjunctiveFacets[name])) {
            options.push({
              label: `${key} (${value})`,
              value: key
            });
          }

          if (type === 'select' || type === 'radios') {
            options.unshift({
              label: '- Any -',
              value: '',
              selected: true
            })
          }

          field.options = options;
          field.isTranslated = false;
        }
        result = field;
      } else if (field.options?.length || type === 'toggle' || field.type === 'range') {
        result = {...field, filter: true};
      }

      if (name === 'field_prgm_options' && field.options) {
        const tooltipsMapping = {
          'Direct Enrollment': intl.formatMessage({id: 'ProgramFinder.SidebarFilters.PrgmOpt.DirectEnrollment.Tooltip'}),
          'Includes Part-time Internship': intl.formatMessage({id: 'ProgramFinder.SidebarFilters.PrgmOpt.Internship.Tooltip'}),
          'Part-Time Internship': intl.formatMessage({id: 'ProgramFinder.SidebarFilters.PrgmOpt.Internship.Tooltip'}),
          'Experiential Learning': intl.formatMessage({id: 'ProgramFinder.SidebarFilters.PrgmOpt.Learning.Tooltip'}),
          'Global Pillars Courses': intl.formatMessage({id: 'ProgramFinder.SidebarFilters.PrgmOpt.Pillars.Tooltip'}),
        };
        field.options = field.options.map((option) => {
          const {value} = option;
          if (tooltipsMapping.hasOwnProperty(value)) {
            return {
              ...option,
              tooltip: tooltipsMapping[value],
            }
          }
          return option
        });
      }

      if (name === 'price_range' && maxPrice) {
        field.max = maxPrice;
        if (parseInt(priceQuery)) {
          field.currentMax = parseInt(priceQuery);
        }
      }

      result = formCallbacks(result);

      return result;
    });
  }, [facets, formConfig, disjunctiveFacets]);

  if (!formConfig) {
    return null;
  }

  const renderFields = () => {
    if (!fields().length) {
      return '';
    }

    return fields().map((field) => {
      if (field.filter) {
        return (
          <FormField fieldConfig={field} state={filtersState} setState={setFilters}/>
        );
      }
      return (
        <FormField fieldConfig={field} state={formState} setState={setFormState}/>
      );
    });
  };

  return (
    <div className="filters-sidebar" style={{visibility: filtersVisibility && 'visible'}}>
      <div className="filters-sidebar__wrapper">
        <div className="filters-sidebar__header justify-between lg:justify-start">
          <h2 className="lg:hidden">
            {intl.formatMessage({id: 'Algolia.SearchPage.Filters.Label'})}
          </h2>
          <Button buttonClasses="button--clear" onClick={() => setFiltersVisibility(false)}>
            <CloseIcon/>
          </Button>
        </div>

        <div className="flex flex-col lg:items-start">
          <div className="flex justify-between mb-20 filters-sidebar__meta hidden lg:block">
            <Button buttonClasses="button--link" onClick={clearCallback}>
              {intl.formatMessage({id: 'Algolia.SearchPage.ClearButton.Label'})}
            </Button>
          </div>
          <div className="grid gap-30 filters-sidebar__filters">
            {renderFields()}
          </div>
        </div>
      </div>

      <div
        className="flex justify-between items-center lg:hidden py-12 px-30 absolute bottom-0 right-0 left-0 shadow-default bg-white z-10">
        <Button buttonClasses="button--small" onClick={() => setFiltersVisibility(false)}>
          {intl.formatMessage({id: 'Algolia.SearchPage.ShowResults.Button'})}
        </Button>
        <Button buttonClasses="button--link" onClick={clearCallback}>
          {intl.formatMessage({id: 'Algolia.SearchPage.ClearButton.Label'})}
        </Button>
      </div>
    </div>
  );
};

export default SidebarFilters;
